import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, inject } from 'intact-vue-next';
import { themes, getCollapseWidth } from './styles';
import template from './aside.vdt';
import { ROOT_LAYOUT, getStyle, defaultWidth } from './helpers';
import { addStyle } from '../utils';
import { useConfigContext } from '../config';
var typeDefs = {
  collapse: Boolean,
  fixed: Boolean,
  theme: themes,
  width: [Number, String],
  collapsedWidth: [Number, String]
};
var defaults = function defaults() {
  return {
    theme: 'dark',
    width: defaultWidth
  };
};
export var Aside = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Aside, _Component);
  function Aside() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.rootLayout = inject(ROOT_LAYOUT);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Aside.prototype;
  _proto.getStyles = function getStyles() {
    var _this$get = this.get(),
      fixed = _this$get.fixed,
      width = _this$get.width,
      collapse = _this$get.collapse,
      collapsedWidth = _this$get.collapsedWidth;
    var style = addStyle(this.get('style'), {
      width: !collapse ? getStyle(width) : getCollapseWidth(collapsedWidth)
    });
    if (!fixed) return style;
    var _this$rootLayout$pars = this.rootLayout.parse(),
      hasFixedHeader = _this$rootLayout$pars.hasFixedHeader,
      headerHeight = _this$rootLayout$pars.headerHeight;
    if (!hasFixedHeader) return style;
    return addStyle(style, {
      top: getStyle(headerHeight)
    });
  };
  return Aside;
}(Component);
Aside.template = template;
Aside.typeDefs = typeDefs;
Aside.defaults = defaults;